import React from "react";
import Text from "../atoms/Text";
import Button from "../atoms/Button";
import socialMedias from "../../assets/Social Medias.png";
import { formatCurrency } from "./ProfileShared";

export default function WishlistProfile({
  wishlistProducts,
  onAddToCart,
  onToggleWishlist,
}) {
  if (wishlistProducts.length === 0) {
    return (
      <div
        style={{
          border: "1px solid var(--gray1)",
          borderRadius: "8px",
          backgroundColor: "var(--white)",
          padding: "24px",
        }}
      >
        <Text size="px24" weight="w500" color="gray9">
          My Wishlist
        </Text>
        <Text size="px16" weight="w400" color="gray5" extraStyles={{ marginTop: "16px" }}>
          Your wishlist is empty.
        </Text>
      </div>
    );
  }

  return (
    <div
      className="wishlist-profile"
      style={{
        border: "1px solid var(--gray1)",
        borderRadius: "8px",
        backgroundColor: "var(--white)",
        overflow: "hidden",
      }}
    >
      <div
        className="wishlist-profile-head"
        style={{
          padding: "24px",
          borderBottom: "1px solid var(--gray1)",
          textAlign: "center",
        }}
      >
        <Text size="px32" weight="w600" color="gray9">
          My Wishlist
        </Text>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "2.1fr 1fr 1fr 0.95fr 40px",
          padding: "16px 28px",
          backgroundColor: "var(--white)",
          borderBottom: "1px solid var(--gray1)",
          alignItems: "center",
        }}
      >
        {["Product", "Price", "Stock Status", "", ""].map((heading, index) => (
          <Text
            key={`${heading}-${index}`}
            size="px12"
            weight="w500"
            color="gray5"
            extraStyles={{ textTransform: "uppercase", textAlign: "start" }}
          >
            {heading}
          </Text>
        ))}
      </div>

      {wishlistProducts.map((item) => (
        <div
          className="wishlist-profile-row"
          key={item.id}
          style={{
            display: "grid",
            gridTemplateColumns: "2.1fr 1fr 1fr 0.95fr 40px",
            padding: "18px 28px",
            borderBottom: "1px solid var(--gray05)",
            alignItems: "center",
            columnGap: "12px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "16px", minWidth: 0 }}>
            <img
              src={item.image}
              alt={item.name}
              style={{ width: "72px", height: "72px", objectFit: "contain", flexShrink: 0 }}
            />
            <Text size="px16" weight="w400" color="gray9">
              {item.name}
            </Text>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <Text size="px16" weight="w500" color="gray9">
              {formatCurrency(item.price)}
            </Text>
            {item.hasDiscount ? (
              <Text
                size="px14"
                weight="w400"
                color="gray4"
                extraStyles={{ textDecoration: "line-through" }}
              >
                {formatCurrency(item.originalPrice)}
              </Text>
            ) : null}
          </div>

          <span
            style={{
              display: "inline-flex",
              width: "fit-content",
              padding: "5px 10px",
              borderRadius: "4px",
              backgroundColor: "#EAF7E9",
              color: "var(--primary)",
              fontSize: "14px",
              fontWeight: 400,
            }}
          >
            In Stock
          </span>

          <Button
            size="small"
            variant="fill"
            onClick={() => onAddToCart(item)}
            style={{
              minWidth: "130px",
              justifySelf: "start",
            }}
          >
            Add to Cart
          </Button>

          <button
            type="button"
            onClick={() => onToggleWishlist(item)}
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              border: "1px solid var(--gray2)",
              backgroundColor: "var(--white)",
              color: "var(--gray4)",
              fontSize: "16px",
              lineHeight: 1,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
            }}
          >
            x
          </button>
        </div>
      ))}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          padding: "20px 28px",
        }}
      >
        <Text size="px14" weight="w400" color="gray5">
          Share:
        </Text>
        <img
          src={socialMedias}
          alt="Social media"
          style={{ width: "184px", height: "40px", objectFit: "contain" }}
        />
      </div>
    </div>
  );
}
